import { inject, injectable } from "inversify";
import {
  GoCardlessSettingsModel,
  ICPLPaymentProvidersClient,
  PaymentProviderModel,
  BlinkSettingsModel,
} from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { PaymentProviders } from "global/enums";

export interface IPaymentProvidersService {
  getPaymentProviders(): Promise<PaymentProviderModel[]>;
  enablePaymentProvider(paymentProvider: PaymentProviders): Promise<void>;
  disablePaymentProvider(): Promise<void>;
  getGoCardlessSettings(): Promise<GoCardlessSettingsModel>;
  updateGoCardlessSettings(goCardlessSettings: GoCardlessSettingsModel): Promise<void>;
  getBlinkSettings(): Promise<BlinkSettingsModel>;
  updateBlinkSettings(blinkSettings: BlinkSettingsModel): Promise<void>;
}

@injectable()
export class PaymentProvidersService implements IPaymentProvidersService {
  @inject(SERVICE_TYPES.CPLPaymentProvidersClient) cplPaymentProvidersClient!: ICPLPaymentProvidersClient;

  async getPaymentProviders(): Promise<PaymentProviderModel[]> {
    return this.cplPaymentProvidersClient.getPaymentProviders();
  }

  async enablePaymentProvider(paymentProvider: PaymentProviders): Promise<void> {
    return this.cplPaymentProvidersClient.enablePaymentProvider(paymentProvider);
  }

  async disablePaymentProvider(): Promise<void> {
    return this.cplPaymentProvidersClient.disablePaymentProvider();
  }

  async getGoCardlessSettings(): Promise<GoCardlessSettingsModel> {
    return this.cplPaymentProvidersClient.getGoCardlessSettings();
  }

  async updateGoCardlessSettings(goCardlessSettings: GoCardlessSettingsModel): Promise<void> {
    return this.cplPaymentProvidersClient.updateGoCardlessSettings(goCardlessSettings);
  }

  async getBlinkSettings(): Promise<BlinkSettingsModel> {
    return this.cplPaymentProvidersClient.getBlinkSettings();
  }

  async updateBlinkSettings(blinkSettings: BlinkSettingsModel): Promise<void> {
    return this.cplPaymentProvidersClient.updateBlinkSettings(blinkSettings);
  }
}
